import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { TextField, Tooltip } from "@mui/material";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Handle, Position } from "reactflow";
import { useTheme } from "../../../contexts/ThemeContext";

export const EndNodeEditModal = ({ open, handleClose, data }) => {
  const { darkMode } = useTheme();
  const isEdit = !!data?.id;

  const currentConfig = data?.data?.config || {};
  const [reason, setReason] = useState(currentConfig.reason || "journey_completed");

  const onSave = () => {
    handleClose({ config: { reason: reason.trim() } }, isEdit);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 440,
    maxWidth: "95vw",
    bgcolor: darkMode ? "#18181b" : "#ffffff",
    border: `1px solid ${darkMode ? "#27272a" : "#e2e8f0"}`,
    borderRadius: 3,
    boxShadow: 24,
    p: 3.5,
  };

  return (
    <Modal open={open} onClose={() => handleClose(null)}>
      <Box sx={modalStyle}>
        <div className="flex items-center gap-2 mb-2">
          <div className="p-2 rounded-lg bg-rose-500/10 text-rose-500">
            <StopCircleIcon />
          </div>
          <div>
            <h2 className={`text-lg font-bold ${darkMode ? "text-white" : "text-slate-900"}`}>
              {isEdit ? "Edit End Journey Node" : "Configure End Journey"}
            </h2>
            <p className={`text-xs ${darkMode ? "text-zinc-400" : "text-slate-500"}`}>
              Terminates the contact enrollment and marks the journey complete.
            </p>
          </div>
        </div>

        <div className="my-4">
          <TextField
            fullWidth
            size="small"
            label="Completion Reason / Exit Code"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="goal_achieved, opted_out, timeout..."
            helperText="Stored in enrollment completionReason for reporting"
          />
        </div>

        <div className="flex justify-end gap-2 pt-3 border-t border-slate-200 dark:border-zinc-700">
          <Button variant="outlined" onClick={() => handleClose(null)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSave}
            style={{ backgroundColor: "#e11d48" }}
          >
            {isEdit ? "Update Node" : "Add Node"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export const EndNode = (props) => {
  const { data, selected, onEdit, onDeleteNode, ...rest } = props;
  const { darkMode } = useTheme();

  const cfg = data?.config || {};
  const reason = cfg.reason || "journey_completed";

  return (
    <div
      className={`w-48 shadow-lg rounded-xl overflow-hidden transition-all duration-200 ${
        darkMode ? "bg-[#18181b] border border-zinc-700" : "bg-white border border-slate-200"
      } ${
        selected ? "ring-2 ring-rose-500 shadow-rose-500/20" : "hover:border-rose-400"
      }`}
    >
      <Handle id="target" type="target" position={Position.Left} />

      <div className="flex items-center justify-between px-3 py-2 bg-gradient-to-r from-rose-600 to-pink-600 text-white">
        <div className="flex items-center gap-1.5 min-w-0">
          <StopCircleIcon style={{ fontSize: 16 }} />
          <span className="text-xs font-semibold tracking-wide uppercase truncate">
            End Journey
          </span>
        </div>
        <div className="flex items-center gap-1">
          <Tooltip title="Edit Exit Reason">
            <EditIcon
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() => onEdit(props)}
            />
          </Tooltip>
          {onDeleteNode && (
            <Tooltip title="Delete Node">
              <DeleteOutlineIcon
                style={{ fontSize: 15, cursor: "pointer" }}
                onClick={() => onDeleteNode(rest.id)}
              />
            </Tooltip>
          )}
        </div>
      </div>

      <div className="p-3">
        <div className={`text-[11px] font-mono truncate px-2 py-1 rounded ${darkMode ? "bg-zinc-800/80 text-rose-300" : "bg-rose-50 text-rose-700"}`}>
          Exit: {reason}
        </div>
        <div className={`text-[10px] mt-1.5 text-center ${darkMode ? "text-zinc-500" : "text-slate-400"}`}>
          Terminal step
        </div>
      </div>
    </div>
  );
};

